export default __webpack_public_path__ + "static/media/work-order.dfa75881.svg";